import { get, postFormData, post, put, del } from '../index'

export const getPublicVoiceList = get('/voice/public/list')
export const getMyVoiceList = get('/voice/mine/list')
export const generateVoice = post('/voice/create')
export const getVoiceProcessing = get('/voice/processing')
export const getPublicOneTone = get('/voice/public/one')
export const createReferAudio = postFormData('/voice/refer')
export const getReferAudioSeat = get('/voice/refer/seat')
export const updateReferAudioName = put('/voice/refer/name')
export const deleteAudio = del('/voice/refer')